import { RowSelectionState } from '@applift/datagrid'

export type ConversionFilter = 'all' | 'pixel' | 'postback'

export const conversionFilterIdMap: { [key: string]: number } = {
  pixel: 1,
  postback: 2,
}

export const conversionFilterMap: {
  [key: string]: Omit<ConversionFilter, 'all'>
} = {
  '1': 'pixel',
  '2': 'postback',
}

export const getConversionTypeIds = (
  conversionType: ConversionFilter
): string => {
  return conversionFilterIdMap[conversionType]
    ? `${conversionFilterIdMap[conversionType]}`
    : ''
}

export type MeasurementPartnerFilter = {
  id: number
  name: string
  logoUrl: string
  order: number
  active: boolean
}

export type ConversionStatusFilter = {
  id: number
  name: string
  displayName: string
  order: number
  active: boolean
}

export interface ListSlice {
  list: {
    filters: {
      conversionType: ConversionFilter
      conversionStatus: ConversionStatusFilter['id'][]
      measurementPartners: MeasurementPartnerFilter['id'][]
      search: string
    }
    rowSelection: RowSelectionState

    resetFilters: () => void
    setConversionTypeFilter: (value: ConversionFilter) => void
    setConversionStatusFilter: (value: ConversionStatusFilter['id'][]) => void
    setMeasurementPartnersFilter: (
      value: MeasurementPartnerFilter['id'][]
    ) => void
    setSearchFilter: (value: string) => void
    setRowSelection: (data: RowSelectionState) => void
  }
}
